import { IArrowRightTrailerProps } from "interfaces";

const ArrowRightTrailerIcon = ({ className, onClick }: IArrowRightTrailerProps) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className={className}
             onClick={onClick}>
            <path
                d="M20.1205 4.43997C20.3739 4.43997 20.6272 4.53331 20.8272 4.73331C21.2139 5.11997 21.2139 5.75998 20.8272 6.14664L12.1339 14.84C11.4939 15.48 11.4939 16.52 12.1339 17.16L20.8272 25.8533C21.2139 26.24 21.2139 26.88 20.8272 27.2666C20.4405 27.6533 19.8005 27.6533 19.4139 27.2666L10.7205 18.5733C10.0405 17.8933 9.65386 16.9733 9.65386 16C9.65386 15.0266 10.0272 14.1066 10.7205 13.4266L19.4139 4.73331C19.6139 4.54664 19.8672 4.43997 20.1205 4.43997Z"/>
        </svg>
    )
}
export default ArrowRightTrailerIcon;